import { Accordion, Center, Flex } from '@chakra-ui/react'
import { isEmpty } from 'lodash'
import { PAYMENT_STATE_LABEL } from 'shared/constants/payments'
import { getDateTimeReadFormat } from 'shared/utils/dateFormatting'
import {
  ContentContainer,
  ContentContainerColumn,
  GridField,
  GridFieldHeading,
  GridFieldItem,
} from 'uikit/layout'
import { useHistoryListFetch } from './services/useHistoryListFetch'

export const HistoryList = ({ id }) => {
  const { data, isPending: isLoading } = useHistoryListFetch(id)


  if (isEmpty(data?.history)) {
    return (
      <ContentContainer>
        <ContentContainerColumn>
          <Center height="100px">Нет истории</Center>
        </ContentContainerColumn>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer>
      <ContentContainerColumn>
        <Accordion.Root defaultValue={['0']} multiple variant="enclosed">
          {data?.history?.map((item, index) => (
            <Accordion.Item key={index} value={String(index)}>
              <Accordion.ItemTrigger cursor="pointer">
                <Flex flex="1" textAlign="left" minH="46px" alignItems="center">
                  {PAYMENT_STATE_LABEL[item.state] || item.state}
                </Flex>
                <Accordion.ItemIndicator />
              </Accordion.ItemTrigger>
              <Accordion.ItemContent>
                <Accordion.ItemBody pb={4}>
                  <GridField>
                    <GridFieldHeading>Данные перевода</GridFieldHeading>
                    <GridFieldItem label="Способ" isLoading={isLoading} isReady>
                      {item?.method}
                    </GridFieldItem>
                    <GridFieldItem label="Дата" isLoading={isLoading} isReady>
                      {getDateTimeReadFormat(item?.createDate)}
                    </GridFieldItem>
                  </GridField>
                  {item?.systemDescription && (
                    <GridField>
                      <GridFieldHeading>Системное сообщение</GridFieldHeading>
                      <GridFieldItem isLoading={isLoading} isReady>
                        {item?.systemDescription}
                      </GridFieldItem>
                    </GridField>
                  )}
                  {item?.userDescription && (
                    <GridField>
                      <GridFieldHeading>Комментарий пользователя</GridFieldHeading>
                      <GridFieldItem isLoading={isLoading} isReady>
                        {item?.userDescription}
                      </GridFieldItem>
                    </GridField>
                  )}
                </Accordion.ItemBody>
              </Accordion.ItemContent>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </ContentContainerColumn>
    </ContentContainer>
  )
}
